import React, { useState } from "react";
import { Outlet } from "react-router-dom";

const DownloadContext = React.createContext(null);

export const useDownloadContext = () => {
  return React.useContext(DownloadContext);
};

function DownloadDataProvider() {
  const [refreshFlag, setRefreshFlag] = useState(true);

  return (
      <DownloadContext.Provider 
    value={{ 
      RefreshFlag: refreshFlag,
      SetRefreshFlag: setRefreshFlag,
    }}>
      <Outlet />
    </DownloadContext.Provider>
  );
}

export default DownloadDataProvider;
